// extracted by css-extract-rspack-plugin
export default {"content":"Qa1XEcNFe4O8xpMH__content___"};